// Multilevel Nav Menu

function multiLevelNav() {
  jQuery(document).ready(function (jQuery) {
    // Initialize dropdown-submenu
    jQuery(".dropdown-menu > li > .dropdown-menu")
      .parent()
      .addClass("dropdown-submenu")
      .find("> .dropdown-item")
      .attr("href", "javascript:;")
      .addClass("dropdown-toggle");

    // Toggle submenu on click
    jQuery(".dropdown-submenu > a").on("click", function (e) {
      var dropdown = jQuery(this).next(".dropdown-menu");
      var dropdownToggle = jQuery(this);

      // Hide other open submenus and remove 'show' from their toggles
      jQuery(".dropdown-submenu .dropdown-menu")
        .not(dropdown)
        .removeClass("show");
      jQuery(".dropdown-submenu > .dropdown-toggle")
        .not(dropdownToggle)
        .removeClass("show");

      // Toggle current submenu
      dropdown.toggleClass("show");

      // Add or remove 'show' on toggle only
      if (dropdown.hasClass("show")) {
        dropdownToggle.addClass("show");
      } else {
        dropdownToggle.removeClass("show");
      }

      e.stopPropagation();
      e.preventDefault();
    });

    // Close submenus when parent dropdown closes
    jQuery(".dropdown").on("hidden.bs.dropdown", function () {
      jQuery(".dropdown-menu.show").removeClass("show");
      jQuery(".dropdown-submenu > .dropdown-toggle.show").removeClass("show");
    });
  });
}
multiLevelNav();

function closeMenu() {
  var navButtons = jQuery("#nav-button, #nav-button-offcanvas");
  var offcanvas = jQuery("#navbarNavOffcanvas");

  offcanvas.on("show.bs.offcanvas", function () {
    navButtons.addClass("opened").attr("aria-expanded", "true");
  });

  offcanvas.on("hide.bs.offcanvas", function () {
    navButtons.removeClass("opened").attr("aria-expanded", "false");
  });
}
closeMenu();

function menuScroll() {
  var prevScrollpos = jQuery(window).scrollTop();

  jQuery(window).on("scroll", function () {
    var currentScrollPos = jQuery(window).scrollTop();
    var $nav = jQuery("#main-nav");
    var isDesktop = jQuery(window).width() > 767;
    var hideTop = isDesktop ? "-180px" : "-160px";

    if (currentScrollPos <= 200) {
      // Above threshold: show nav with transparent background
      $nav
        .css({
          top: "0",
          background: "transparent",
        })
        .removeClass("scrolling");
    } else {
      if (prevScrollpos > currentScrollPos) {
        // Scrolling up past 200: show nav with dark background
        $nav
          .css({
            top: "0",
            background: "#253237",
          })
          .addClass("scrolling");
      } else {
        // Scrolling down past 200: hide nav and keep dark background
        $nav.css({
          top: hideTop,
          background: "#253237",
        });
      }
    }

    prevScrollpos = currentScrollPos;
  });
}
menuScroll();

function acredSlider() {
  var swiper = new Swiper(".acredSwiper", {
    loop: true,
    slidesPerView: 2,
    spaceBetween: 30,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      761: {
        spaceBetween: 60,
        slidesPerView: 4,
      },
      991: {
        spaceBetween: 100,
        slidesPerView: 5,
      },
    },
  });
}
acredSlider();

function fullWidthGallery() {
  var swiper = new Swiper(".fullWidthGallery", {
    pagination: {
      el: ".swiper-pagination",
    },
    spaceBetween: 30,
    centeredSlides: true,
    slidesPerView: 1,
    loop: true,
    breakpoints: {
      761: {
        slidesPerView: 3,
      },
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });
}
fullWidthGallery();

jQuery(function (jQuery) {
  var clickTimer = null;

  jQuery(".menu-item-has-children > a").on("click", function (e) {
    var $this = jQuery(this);

    if (clickTimer === null) {
      // First click: prevent default (show dropdown)
      e.preventDefault();
      clickTimer = setTimeout(function () {
        clickTimer = null;
      }, 300); // wait 300ms for possible second click
    } else {
      // Second click: follow the link
      clearTimeout(clickTimer);
      clickTimer = null;
      window.location = $this.attr("href");
    }
  });
});
